import { Box, Button, Divider, Drawer, IconButton, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import invLogo from "../data/images/Inv-logoHorizontal.png"
import MenuIcon from '@mui/icons-material/Menu';
import React from 'react';
import { useMediaQuery } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const HeaderComponent = () => {
    const navigate = useNavigate();
    const isXs = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const [drawerOpen, setDrawerOpen] = React.useState(false);
    const toggleDrawer = (open) => (event) => {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setDrawerOpen(open);
    };

    return (
        <Box sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            // width: "100vw",
            height: "3.5rem",
            background: "#f8f9f9"
        }}>
            <Box pl={2} >
                <Box component="img"
                    sx={{
                        width: {
                            xs: 150,
                            md: 200,
                        },
                        cursor: "pointer"
                    }}
                    alt="INV Logo"
                    src={invLogo}
                    onClick={() => navigate('/')}
                />
            </Box>
            <Box pr={2}>
                {isXs ? (
                    <>
                        <IconButton onClick={toggleDrawer(true)} >
                            <MenuIcon />
                        </IconButton>
                        <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
                            <Box
                                role="presentation"
                                onClick={toggleDrawer(false)}
                                onKeyDown={toggleDrawer(false)}
                                sx={{ width: "250px", display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}
                            >
                                <Box textAlign="start" pl={2} width="100%" mt="10px">
                                    <IconButton onClick={toggleDrawer(false)}>
                                        <ArrowForwardIosIcon color="info" />
                                    </IconButton>
                                </Box>
                                <Box width="100%"><Divider /></Box>
                                {/* <Link href="/login-creator" underline="hover" sx={{color: "#566573", fontWeight: "bold"}} >Admin Login</Link> */}
                                <Link href="/terms-n-conditions" underline="hover" sx={{color: "#566573", fontWeight: "bold"}}>Terms & Conditions</Link>
                                <Link href="/privacy-policy" underline="hover" sx={{color: "#566573", fontWeight: "bold"}}>Privacy Policy</Link>
                                <Link href="/refund-policy" underline="hover" sx={{color: "#566573", fontWeight: "bold"}} >Refund Policy</Link>
                            </Box>
                        </Drawer>
                    </>
                ) : (
                    <Box sx={{ display: "flex", gap: "20px", paddingRight: "20px" }}>
                        {/* <Link href="/login-creator" underline="hover" sx={{ color: "#566573", fontWeight: "bold" }}>Admin Login</Link> */}
                        <Link href="/terms-n-conditions" underline="hover" sx={{ color: "#566573", fontWeight: "bold" }}>Terms & Conditions</Link>
                        <Link href="/privacy-policy" underline="hover" sx={{ color: "#566573", fontWeight: "bold" }}>Privacy Policy</Link>
                        <Link href="/refund-policy" underline="hover" sx={{ color: "#566573", fontWeight: "bold" }}>Refund Policy</Link>
                    </Box>
                )}
            </Box>
        </Box>
    )
}
export default HeaderComponent;